import React, {useState} from 'react';
import { ToggleSwitch } from './ToggleSwitch';  // Update path
import { IconContext } from 'react-icons';
import { RiDeleteBin6Line } from 'react-icons/ri';
import '../styles/warning.css'

const QueryToggle = ({ label, is_active, onToggle, onDelete }) => {
  const [showModal, setShowModal] = useState(false);

  const handleDeleteClick = () => {
    setShowModal(true);
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  const handleModalDelete = () => {
    onDelete();
    setShowModal(false);
  };
  const DeleteModal = ({ show, onClose, onDelete }) => {
    return (
      <div className={`wmodal ${show ? 'show' : 'hide'}`}>
        <div className="wmodal-content">
          <span className="wclose" onClick={onClose}>&times;</span>
          <p>Do you really want to delete?</p>
          <div className="button-container">
          <button className="yes" onClick={onDelete}>Yes</button>
          <button className="no" onClick={onClose}>No</button>
        </div>
        </div>
      </div>
    );
  }
  
  
  return (
     <div className="query-line">
     <DeleteModal 
        show={showModal} 
        onClose={handleModalClose} 
        onDelete={handleModalDelete} 
      />
       <label className="inline-label">{label}</label>
       <div className="toggle-wrapper">
         <ToggleSwitch
           is_active={is_active}
           onToggle={onToggle} 
         />
       </div>
       <button onClick={handleDeleteClick} className="delete-button">
         <IconContext.Provider value={{ className: "delete-icon" }}>
           <RiDeleteBin6Line />
         </IconContext.Provider>
       </button>
     </div>
   );
  }

  export default QueryToggle;